import {Component, OnInit} from '@angular/core';
import {Globals} from '../globals';
import {NgForm} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {LoginService} from '../core/services/login.service';
import {ToastrService} from 'ngx-toastr';
import {HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private globals: Globals,
              private cookieService: CookieService,
              private loginService: LoginService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
  }

  onSubmit(data: NgForm) {
    this.login(data.value.login, data.value.password);
  }

  private login(user: String, password: String) {
    const adminInput = document.getElementById('adminLogin') as HTMLInputElement;
    if (adminInput.checked) {
      this.loginService.get(user, password).subscribe(response => {
          if (response.access_token) {
            this.globals.isUserLoggedIn = true;
            this.globals.isCreateApplication = false;
            this.cookieService.set('UVMAppLoggedInToken', response.access_token, 0.04);
            this.toastr.success('Logged in successfully!', 'Success!');
          }
          this.loginService.updateCache(response);
        }, (error: HttpErrorResponse) => {
          this.toastr.error('Error logging in', 'Failure!');
        }
      );
    } else {
      this.loginService.getCommunityUser(user, password).subscribe(response => {
        if (response.result === 'SUCCESS') {
          this.globals.isUserLoggedIn = true;
          this.globals.isCreateApplication = false;
          this.cookieService.set('UVMAppLoggedInToken', response.token, 0.04);
          this.toastr.success('Logged in successfully!', 'Success!');
        } else {
          this.toastr.error('Error logging in', 'Failure!');
        }
        this.loginService.updateCache(response);
      }, (error: HttpErrorResponse) => {
        this.toastr.error('Error logging in', 'Failure!');
      });
    }


  }

}
